import { URLLike, toURL, parseSearch, newSearch } from './codec';

// 矫正 hash & query 的顺序
export const hashModeURL = (url: URLLike = location) => {
  const u = toURL(url);
  const { search: origin, hash } = u;
  const [h, search] = hash.split('?');

  const s = newSearch(Object.assign(
    parseSearch(origin),
    parseSearch(search ? `?${search}` : undefined),
  ));
  u.search = s ? `?${s}` : '';
  u.hash = h;
  return u;
};

export const toHttps = (url?: URLLike) => {
  const u = toURL(url);
  u.protocol = 'https:';
  return u;
};
